import HLS from 'hls.js';
import HTML5 from './html5-player-events';
/**
 *
 * @module HLSJS media events enum
 * @desc Media event enumeration
 *
 */

export default {
    ...HTML5,
    ...HLS.Events,
};
